import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

interface RevealOptions {
    trigger: string;
    image?: string;
    text?: string;
}

export const useGsapReveal = (options: RevealOptions, deps: any[] = []) => {
    const tlRef = useRef<gsap.core.Timeline | null>(null);

    useEffect(() => {
        // 清理前一次
        if (tlRef.current) {
            tlRef.current.kill();
            ScrollTrigger.refresh();
        }

        const { trigger, image, text } = options;

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger,
                start: 'top 80%',
                toggleActions: 'restart none none reset',
            },
        });

        if (image) {
            tl.from(image, {
                clipPath: 'inset(100% 0% 0% 0%)',
                duration: 1.2,
                ease: 'power2.out',
            });
        }

        if (text) {
            tl.from(
                text,
                {
                    y: -30,
                    opacity: 0,
                    duration: 0.8,
                    ease: 'power3.out',
                },
                '-=0.5',
            );
        }

        tlRef.current = tl;

        return () => {
            tl.kill();
            ScrollTrigger.refresh();
        };
    }, deps); // ⭐这里决定了什么时候重新执行动画
};
